var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.281,
    height: 48.086,
    viewBox: "0 0 48.281 48.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105404",
    "data-name": "Group 105404",
    transform: "translate(-478.635 -423.373)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 24.14,
    cy: 24.043,
    rx: 24.14,
    ry: 24.043,
    transform: "translate(478.635 423.373)",
    fill: "#29c6f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-users-446035",
    transform: "translate(489.635 437.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105328",
    "data-name": "Path 105328",
    d: "M201.812,98.861a6.407,6.407,0,0,0,2.486-5c0-2.779-2.122-4.266-4.759-4.266-2.607,0-4.759,1.488-4.759,4.266a6.407,6.407,0,0,0,2.486,5c-3.637.758-6.3,3.228-6.3,5.557.06,2.779,3.88,4.266,8.609,4.266s8.548-1.488,8.548-4.266C208.116,102.089,205.449,99.619,201.812,98.861Z",
    transform: "translate(-185.928 -89.599)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105329",
    "data-name": "Path 105329",
    d: "M453.85,167.62a3.549,3.549,0,0,0,1.394-2.807,2.681,2.681,0,0,0-5.335,0,3.64,3.64,0,0,0,1.394,2.807,5.6,5.6,0,0,0-2.182.954c2.092,1.123,3.547,2.835,3.759,4.575,2.516-.084,4.516-.9,4.516-2.414,0-1.291-1.516-2.694-3.546-3.115Z",
    transform: "translate(-430.117 -158.751)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105330",
    "data-name": "Path 105330",
    d: "M106.277,168.576a5.81,5.81,0,0,0-2.182-.954,3.549,3.549,0,0,0,1.394-2.807,2.681,2.681,0,0,0-5.335,0,3.64,3.64,0,0,0,1.394,2.807c-2.031.421-3.546,1.824-3.546,3.115,0,1.516,2,2.33,4.516,2.386.212-1.712,1.667-3.424,3.759-4.547Z",
    transform: "translate(-98.002 -158.752)",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.757cad40572cdc408ce5ccba1ce41c01.svg";
export { ForwardRef as ReactComponent };